import { observer } from "mobx-react";
import React from "react";

export interface CustomTableProps {
  headers: JSX.Element[];
  rows: JSX.Element[];
  createNewRecord?: () => void;
  dataTestID?: string;
  addNewTemplateString?: string;
}

function CustomTable({
  headers,
  rows,
  createNewRecord,
  dataTestID,
  addNewTemplateString,
}: CustomTableProps) {
  return (
    <div
      className="vdd-templates-wrapper without-first-block"
      style={{ maxWidth: "100%" }}
      data-testid={dataTestID}
    >
      <div className="table-list-wrap">
        <div className="list-title-table">
          <ul>
            <div className="list-column-wrap">
              <div className="list-title-table-wrap">
                {headers}
                <span className="stretch-cell" />
              </div>
            </div>
          </ul>
        </div>
        {createNewRecord && (
          <div
            className="create-new-record before-records"
            style={{ paddingRight: 0 }}
            data-testid="custom-table-add-new"
          >
            <button
              type="button"
              onClick={createNewRecord}
              data-testid={`${dataTestID}-button`}
            >
              {addNewTemplateString}
            </button>
          </div>
        )}
        {rows}
      </div>
    </div>
  );
}

export default observer(CustomTable);
